<template>
  <div :class="[$style.summary, $style[targetTmp.name]]" :style="summaryStyle">
    <!-- 关闭ICON -->
    <img :src="targetTmp.close" alt :class="$style.close" @click="close" :style="closeStyle"/>
    <!-- 活动计划标题ICON -->
    <img :src="targetTmp.title" alt :class="$style.titleIcon" @click="clearStorage"  :style="titleIconStyle"/>
    <!-- 活动分类列表 -->
    <ul :class="$style.classify"  :style="classifyWrapStyle">
      <li
        v-for="(item, index) in model.sum_menu"
        :key="index"
        :class="`${item.redDot && item.redDot.length ? $style.redDot : ''
        } ${$style.classifyItem}`"
        @click="setClassify(item)"
        :style="currentClassify.name === item.name ? activeClassifyStyle : classifyStyle"
      >
        <p :class="$style.font" v-if="targetTmp.specialFont">
          <span :class="$style.stroken">{{ item.name }}</span>
          <span :class="$style.text">{{ item.name }}</span>
        </p>
        <p v-else :class="$style.commonFont">{{ item.name }}</p>
      </li>
    </ul>
    <!-- 活动分类下的活动列表 -->
    <ul :class="$style.activity">
      <li
        v-for="(item, index) in currentClassify.activity"
        :key="index"
        :class="`${currentActivity.name === item.name ? $style.active : ''} ${item.red_notice == 1 ? $style.redDot : ''
        }  ${$style.activityItem}`"
        @click="setActivity(item)"
      >
        <span :class="$style.tag" v-if="item.text_tag">{{ item.text_tag }}</span>
        <span  :class="$style.text">{{ item.name }}</span>
      </li>
    </ul>
    <div 
      v-if="currentActivity.activity_id"
      :style="{ backgroundImage: `url(${currentActivity.background})`, ...actBackStyle }" 
      @click="handleBtnClick(currentActivity.button_list[0])"
      :class="`${currentActivity.button_list[0].function == 2 ? 'copy-btn' : ''} ${$style.activityContent}`"
      :data-clipboard-text="currentActivity.button_list[0].function_value"
    ></div>
    <!-- 复制输入框 -->
    <input type="text" :class="$style.copyInput" id="copy" readonly :value="inputVal" />
    <BoxDownload v-if="boxDownLoadShow" @close="boxDownLoadShow=false" :type="boxType"></BoxDownload>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapMutations, mapActions } from 'vuex';
import { gameOpenDownloads, registSaveImgFunction, boxSkipAnyPage2Sdk, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { getStorage, setStorage, y_portrait } from '@/libs/utils';
import { generActLink } from '@/libs/business/box';
import { eventTrack } from '@/api/user'
import { boxDownloadUrl, wxBoxDownloadUrl } from '@/config'
import BoxDownload from '../Suspend/common/boxDownload.vue'
import { buryReportV2 } from '@/libs/business/account'
import config from './config'

export default {
  name: '',
  props: {
    model: {
      default: () => { }
    },
    isH5: {
      default: false
    },
    isSuspend: {
      default: false
    }
  },
  mounted() {
    console.log(this.model)
    this.setClassify(this.model.sum_menu[0], 1);
    this.getRedDotHistory();
    this.enterBuryReport()
    this.setStyle();
    setTimeout(() => {
      this.copyInit();
    }, 500);
  },
  data() {
    return {
      tagList: {
        1: `${this.$cdnLink}/flashPage/top_1.png`,
        2: `${this.$cdnLink}/flashPage/top_2.png`,
        3: `${this.$cdnLink}/flashPage/top_3.png`
      },
      currentClassify: {},
      currentActivity: {},
      inputVal: '',
      redDotHistory: '', // 点击过的红点列表
      boxDownLoadShow: false,
      boxType: 'bt',
      targetTmp: {},
      summaryStyle: {},
      closeStyle: {},
      titleIconStyle: {},
      classifyWrapStyle: {},
      activeClassifyStyle: {},
      classifyStyle: {},
      activityUlStyle: {},
      actBackStyle: {}
    };
  },
  computed: {
  },
  components: {
    BoxDownload
  },
  methods: {
    ...mapActions({
      btnReport: 'activity/report',
      setRedDot: 'activity/setRedDot',
      openCustomer: 'global/openCustomer'
    }),
    setStyle() {
      this.targetTmp = config[this.model.page_template_id] || config[3];
      // this.targetTmp = config[6] ;
      this.closeStyle = this.targetTmp.closeStyle;
      this.summaryStyle = {
        background: `url(${this.targetTmp.background}) no-repeat`,
        backgroundSize: '100% 100%'
      }
      this.classifyWrapStyle = this.targetTmp.classifyWrapStyle || {
        marginTop: '26px'
      }
      this.titleIconStyle = this.targetTmp.titleIconStyle || {};
      this.activityUlStyle = (y_portrait() ? this.targetTmp.pActivityUlStyle : this.targetTmp.activityUlStyle) || {};
      this.classifyStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        width: '105px',
        height: '100%',
        display: 'flex',
        flex: 'none',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingBottom: '13px',
      }
      this.classifyStyle = this.targetTmp.classifyStyle ? { ...this.classifyStyle, ...this.targetTmp.classifyStyle } : this.classifyStyle;
      this.activeClassifyStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        width: '105px',
        height: '100%',
        display: 'flex',
        flex: 'none',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingBottom: '13px',
        background: `url(${this.targetTmp.classifySelected}) no-repeat`,
        backgroundSize: '100% 100%'
      }
      this.activeClassifyStyle = this.targetTmp.activeClassifyStyle ? { ...this.activeClassifyStyle, ...this.targetTmp.activeClassifyStyle } : this.activeClassifyStyle;
      // this.activityStyle = {
      //   fontSize: '14px',
      //   fontWeight: 400,
      //   color: `#${this.targetTmp.actColor}`,
      //   width: '100%',
      //   height: '45px',
      //   display: 'flex',
      //   alignItems: 'center',
      //   // paddingLeft: '10px',
      //   background: `url(${this.targetTmp.act}) no-repeat`,
      //   backgroundSize: '100% 100%',
      //   boxSizing: 'border-box',
      //   position: 'relative',
      //   justifyContent: 'center',
      // }
      this.actBackStyle = this.targetTmp.actBackStyle || {};
      // this.activeActivityStyle = {
      //   fontSize: '14px',
      //   fontWeight: 400,
      //   width: '100%',
      //   height: '45px',
      //   display: 'flex',
      //   alignItems: 'center',
      //   justifyContent: 'center',
      //   // paddingLeft: '10px',
      //   background: `url(${this.targetTmp.actSelected}) no-repeat`,
      //   backgroundSize: '100% 100%',
      //   boxSizing: 'border-box',
      //   position: 'relative',
      // }
    },
    enterBuryReport() {
      if (this.isSuspend) {
        buryReportV2('SDK_ACTIVITY_PAGE_FROM_BANNER', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
      } else {
        buryReportV2('SDK_ACTIVITY_PAGE_FROM_FLOAT', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
      }
    },
    close() {
      if (this.isSuspend) {
        buryReportV2('SDK_ACTIVITY_BUTTON_CLOSE', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
      } else {
        buryReportV2('SDK_ICON_ACTIVITY_BUTTON_CLOSE', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
      }
      this.$emit('close');
    },
    // 清空红点缓存，测试使用
    clearStorage() {
      setStorage('red_dot_history', '');
    },
    // 获取点击过的列表
    async getRedDotHistory() {
      try {
        let redDotHistory = getStorage('red_dot_history');
        const user_id = getStorage('user_id');
        if (redDotHistory) {
          redDotHistory = JSON.parse(redDotHistory);
          this.redDotHistory = redDotHistory[user_id] || {};
        }
      } catch (error) { }
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
        this.copy.destroy();
      });
    },
    setClassify(e, flag) {
      if (!e) return;
      this.currentClassify = e;
      this.setActivity(e.activity[0], flag);
    },
    setActivity(e, flag) {
      this.currentActivity = e;
      // 若是初始化时候设置当前显示活动内容，不处理红点
      // if (flag) return;
      if (e.red_notice == 1) {
        e.red_notice = 0;
        this.setRedDot(e);
      }
    },
    async handleBtnClick(btnItem) {
      if (this.isSuspend) {
        buryReportV2('SDK_ACTIVITY_BUTTON', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
      } else {
        buryReportV2('SDK_ICON_ACTIVITY_BUTTON', {
          sum_id: this.model.sum_id,
          sum_name: this.model.sum_name,
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        });
        const user_id = getStorage('user_id');
        const appkey = getStorage('appkey');
        this.btnReport({
          type: 'button',
          user_id,
          activity_id: this.currentActivity.activity_id,
          appkey
        });
      }
      // 1跳转链接 2点击复制 3保存图片 4跳转SDK功能页
      let url = btnItem.function_value
      switch (btnItem.function) {
        case 1:
          this.$emit('showGift', this.currentActivity);
          // 如果是跳转盒子协议的地址，需要拼接上用户信息和参数
          if (btnItem.function_value.indexOf('wxbt://com.hzwx.bt.box') !== -1) {
            url = await generActLink(url);
            this.boxType = 'bt';
            this.boxDownLoadShow = true
          } else if (btnItem.function_value.indexOf('wxsy://com.hzwx.wx.box') !== -1) {
            url = await generActLink(url);
            this.boxType = 'wx';
            this.boxDownLoadShow = true
          }
          gameOpenDownloads({
            gameUrl: url
          });
          break;
        case 2:
          this.inputVal = btnItem.function_value;
          this.copyInit();
          break;
        case 3:
          registSaveImgFunction(this.currentActivity.background);
          break;
        case 4:
          this.showSdkComponent(btnItem.function_value);
          break;
        case 5:
          boxSkipAnyPage2Sdk({
            boxUrl: boxDownloadUrl(),
            routePath: btnItem.function_value
          })
          break;
        case 6:
          skipWXBox2Sdk({
            event: 'boxAnyPage',
            syAppkey: "",
            boxUrl: wxBoxDownloadUrl(),
            routePath: btnItem.function_value
          })
          break;
        default:
          break;
      }
    },
    /* 1.绑定手机 2.联系客服 3,。实名认证 */
    showSdkComponent(type) {
      if (type == 1) {
        this.$emit('showBind');
      } else if (type == 2) {
        this.openCustomer();
      } else if (type == 3) {
        this.$emit('showRealName');
      } else if (type == 4) {
        this.$emit('redirectFloatPage', 'welfare')
        this.$setStorage('buryport', {
          upload_type: '活动跳转上报',
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        })
      } else if (type == 5) {
        this.$emit('redirectFloatPage', 'hangup')
        this.$setStorage('buryport', {
          upload_type: '活动跳转上报',
          activity_id: this.currentActivity.activity_id,
          activity_name: this.currentActivity.name,
        })
      }
    },
  }
};
</script>

<style lang="scss" module>
/* 默认横屏样式 */
.summary {
  .close {
    position: absolute;
    top: 13px;
    right: 15px;
    width: 26px;
    height: 26px;
  }
  .titleIcon {
    position: absolute;
    left: 25px;
    top: 34px;
    width: 100px;
    display: inline-block;
    @media screen and (orientation: portrait) {
      display: none;
    }
  }
  .classify {
    display: flex;
    height: 45px;
    align-items: center;
    margin-left: 125px;
    width: 350px;
    overflow-x: auto;
    font-size: 0;
    .redDot {
      position: relative;
      &:before {
        position: absolute;
        content: " ";
        top:  5px;
        right: 0px;
        width: 12px;
        height: 12px;
        background: url('#{$cdn-url}/act-plan/ptfl/7.png?v=1') no-repeat;
        background-size: 100% 100%;
        /* @media screen and (orientation: portrait) {
          width: 0.12rem;
          height: 0.12rem;
        } */
      }
    }
    .font {
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      position: relative;
      .stroken {
        -webkit-text-stroke: 3px rgba(0,0,0,0.45);
      }
      .text {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        background: linear-gradient(-3deg,rgba(255,202,5,0.87) 0%, rgba(255,239,214,0.87) 100%);;
        -webkit-background-clip:text; 
        -webkit-text-fill-color:transparent;
        &::before{
          content: attr(text);
          position: absolute;
          color: red;
          -webkit-mask: linear-gradient(to top,transparent,black);
        }
      }
    }
    .classifyItem {
      background-size: 100% 100%!important;
      background-repeat: no-repeat;
    }
    @media screen and (orientation: portrait) {
      /* width: 6.2rem; */
      margin-left: 20px;
      height: 42px;
    }
  }
  .activity {
    position: absolute;
    bottom: 12px;
    left: 25px;
    height: calc(100% - 82px);
    width: 106px;
    overflow: auto;
    font-size: 0;
    z-index: 10;
    .tag {
      position: absolute;
      top: 0;
      left: 0;
      min-width: 30px;
      height: 14px;
      display: inline-block;
      background: url('#{$cdn-url}/act-plan/ptfl/8.png?v=1') no-repeat;
      background-size: 100% 100%;
      font-size: 9px;
      color: #d2bc7b;
      padding-left: 4px;
      padding-right: 8px;
      line-height: 14px;
      /* @media screen and (orientation: portrait) {
        width: 0.6rem;
      } */
    }
    .font {
      display: inline-block;
      font-size: 14px;
      font-weight: 700;
      position: relative;
      .stroken {
        -webkit-text-stroke: 3px rgba(0,0,0,0.45);
      }
      .text {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        background: linear-gradient(-3deg,rgba(255,202,5,0.87) 0%, rgba(255,239,214,0.87) 100%);;
        -webkit-background-clip:text; 
        -webkit-text-fill-color:transparent;
        &::before{
          content: attr(text);
          position: absolute;
          color: red;
          -webkit-mask: linear-gradient(to top,transparent,black);
        }
      }
    }
    .activityItem {
      background-size: 100% 100%!important;
      background-repeat: no-repeat;
    }
    .redDot {
      position: relative;
      &:before {
        position: absolute;
        content: " ";
        top: 5px;
        right: 5px;
        width: 12px;
        height: 12px;
        background: url('#{$cdn-url}/act-plan/ptfl/7.png?v=1') no-repeat;
        background-size: 100% 100%;
        /* @media screen and (orientation: portrait) {
          width: 2px;
          height: 2rem;
        } */
      }
    }
    @media screen and (orientation: portrait) {
      left: 18px;
      height: calc(100% - 80px);
    }
  }
  .activityContent {
    position: absolute;
    width: 402px;
    height: 226px;
    left: 105px;
    background-size: 100% 100%;
    @media screen and (orientation: portrait) {
      // height: calc(100% - 0.96rem);
      left: 20px!important;
      width: 312px!important;
      height: 195px!important;
    }
  }
  .btn {
    background-size: 100% 100%!important;
    background-repeat: no-repeat;
  }
  .copyInput {
    position: absolute;
    left: -1000px;
    top: -1000px;
  }
  &.ptfl {
    .classify {
      .commonFont {
        color: #710F16;
      }
    }
    .activity {
      .activityItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        // paddingLeft: 10px,
        box-sizing: border-box;
        position: relative;
        justify-content: center;
        background: url('#{$cdn-url}/act-plan/ptfl/4.png?v=1') no-repeat;
        .text {
          color: #C0A263; 
        }
        &.active {
          background: url('#{$cdn-url}/act-plan/ptfl/6.png?v=1') no-repeat;
          background-size: 100% 100%;
          .text {
            background: linear-gradient(-3deg,rgba(255,202,5,0.87) 0%, rgba(255,239,214,0.87) 100%);;
            -webkit-background-clip:text; 
            -webkit-text-fill-color:transparent;
          }
        }
      }
    }
  }
  &.fgcq {
    .classify {
      .commonFont {
        color: #710F16;
      }
    }
    .activity {
      left: 34px;
      width: 90px;
      height: calc(100% - 82px);
      @media screen and (orientation: portrait) {
        left: 22px;
        width: 96px;
        height: calc(100% - 74px);
      }
      .activityItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        // paddingLeft: 10px,
        box-sizing: border-box;
        position: relative;
        justify-content: center;
        background: url('#{$cdn-url}/act-plan/fgcq/4.png?v=1') no-repeat;
        .text {
          color: #B1A070; 
        }
        &.active {
          background: url('#{$cdn-url}/act-plan/fgcq/6.png?v=1') no-repeat;
          background-size: 100% 100%;
          .text {
            color: #D1C8AF;
          }
        }
      }
    }
  }
  &.gq {
    .classify {
      height: 50px;
      padding-top: 11px;
      .redDot {
        position: relative;
        &:before {
          top:  0px;
          right: 0px;
        }
      }
      .font {
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        position: relative;
        .stroken {
          -webkit-text-stroke: 3px #A40000;
        }
        .text {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          background: linear-gradient(-3deg,#FFFFCA 0%, #FFFFCA 100%);;
          -webkit-background-clip:text; 
          -webkit-text-fill-color:transparent;
          &::before{
            content: attr(text);
            position: absolute;
            color: red;
            -webkit-mask: linear-gradient(to top,transparent,black);
          }
        }
      }
      .classifyItem {
        padding-bottom: 10px!important;
      }
      .commonFont {
        color: #710F16;
      }
    }
    .activity {
      left: 24px;
      width: 100px;
      height: calc(100% - 88px);
      @media screen and (orientation: portrait) {
        left: 22px;
        width: 96px;
        height: calc(100% - 74px);
      }
      .activityItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 37px;
        display: flex;
        align-items: center;
        // paddingLeft: 10px,
        box-sizing: border-box;
        position: relative;
        justify-content: center;
        background: url('#{$cdn-url}/act-plan/gq/4.png?v=1') no-repeat;
        .text {
          color: #FFC782; 
        }
        &.active {
          background: url('#{$cdn-url}/act-plan/gq/6.png?v=1') no-repeat;
          background-size: 100% 100%;
          .text {
            color: #FFFFCA;
          }
        }
      }
    }
  }
  &.kxcq {
    .classify {
      .commonFont {
        color: #710F16;
      }
    }
    .activity {
      left: 30px;
      width: 90px;
      height: calc(100% - 78px);
      @media screen and (orientation: portrait) {
        left: 22px;
        width: 96px;
        height: calc(100% - 74px);
      }
      .activityItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        // paddingLeft: 10px,
        box-sizing: border-box;
        position: relative;
        justify-content: center;
        background: url('#{$cdn-url}/act-plan/kxcq/4.png?v=1') no-repeat;
        .text {
          color: #F2B482;
        }
        &.active {
          background: url('#{$cdn-url}/act-plan/kxcq/6.png?v=1') no-repeat;
          background-size: 100% 100%;
          .text {
            color: #FEEFB2; 
          }
        }
      }
    }
  }
  &.xx {
    .classify {
      .commonFont {
        color: #710F16;
      }
    }
    .activity {
      left: 34px;
      width: 90px;
      height: calc(100% - 78px);
      @media screen and (orientation: portrait) {
        left: 22px;
        width: 96px;
        height: calc(100% - 74px);
      }
      .activityItem {
        font-size: 14px;
        font-weight: 400;
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        // paddingLeft: 10px,
        box-sizing: border-box;
        position: relative;
        justify-content: center;
        background: url('#{$cdn-url}/act-plan/xx/4.png?v=1') no-repeat;
        .text {
          background-image: -webkit-linear-gradient(180deg,#f8ca9d 0%, rgba(252,205,186,1.00) 100%);
          -webkit-background-clip:text; 
          -webkit-text-fill-color:transparent; 
        }
        &.active {
          background: url('#{$cdn-url}/act-plan/xx/6.png?v=1') no-repeat;
          background-size: 100% 100%;
          .text {
            background-image: -webkit-linear-gradient(0deg,#ff3007 0%, #57110a 100%);
            -webkit-background-clip:text; 
            -webkit-text-fill-color:transparent; 
          }
        }
      }
    }
  }
}
</style>